export default __webpack_public_path__ + "static/media/kolosova.7c0db441.jpg";